import React, { Component } from 'react';
import Lightbox from '../../components/utility/Lightbox';
import './LevelUp.css';
import CardSelector from './CardSelector';
import Img from '../../StableImage';

export default class LevelUp extends Component {

  render () {

    return (
      <div className="level-up-screen">
        <div className="fight-loot-card lightbox-container">
          <div className="lightbox-inner">
            <div className="level-up-comparison">
              <div className="level">
                <Img key={"level-up-previous-" + (this.props.champion.level-1)} className="level previous-level" src={this.props.champion.imageFor(this.props.champion.level-1)}/>
                <Img key={"level-up-new-" + this.props.champion.level} className="level new-level" src={this.props.champion.imageFor(this.props.champion.level)}/>
                <div className="level-indicator previous-level">{"Lv." + (this.props.champion.level-1)}</div>
                <div className="level-indicator new-level">{"Lv." + (this.props.champion.level)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

